import Image from 'next/image';
import { useMedia } from 'react-use';

import { fontStyles } from '../../../styles/typography';
import { breakpoints } from '../../../styles/util';

export function DeepLiquiditySection() {
  const isMobile = useMedia(breakpoints.mobile, false);

  return (
    <section
      className="bg-token-gray-200 border border-token-gray-300 max-w-[1240px] overflow-hidden mx-auto mb-20 desktop:mb-[100px] pt-16 desktop:pt-16 pr-0 desktop:pr-[84px] rounded-xl flex flex-col desktop:flex-row justify-start desktop:justify-between items-center desktop:items-start relative desktop:h-[460px]"
      style={{
        background: `url(/images/liquidity-sources/diagonal-lines.svg) no-repeat left 117px, url(/images/liquidity-sources/ring-lines.svg) no-repeat right ${isMobile ? 'center' : 'bottom'}, var(--color-token-gray-200)`,
      }}
    >
      <div>
        <h2
          className={fontStyles({
            variant: 'H2',
            class: [
              'ml-13.5',
              'desktop:ml-15',
              'mr-13.5',
              'desktop:mr-0',
              'mb-4',
              'grid',
              'text-center',
              'desktop:text-left',
            ],
          })}
        >
          <span className="text-token-gray-800">Deep liquidity.</span> AMM and RFQ combined.
        </h2>
        <p
          className={fontStyles({
            variant: 'BODY_LG',
            class: ['desktop:ml-15', 'text-token-gray-800', 'text-center', 'desktop:text-left'],
          })}
        >
          Matcha combines 130+ liquidity
          <br /> sources, on-chain and off-chain.
        </p>
      </div>
      <Image
        src="/images/swap-tokens/deep-liquidity.png"
        className="mt-20 tablet:mt-12 desktop:mt-0 max-w-full h-auto"
        alt=""
        width={isMobile ? 407 : 600}
        height={isMobile ? 228 : 336}
      />
      <Image
        src="/images/liquidity-sources/left-tokens.png"
        className="desktop:absolute mx-auto desktop:mx-auto max-w-full h-auto bottom-0 desktop:-left-[34px]"
        alt=""
        width={384}
        height={194}
      />
    </section>
  );
}
